import * as React from 'react';
export const bohSvg = React.forwardRef(function bohSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#1C479A',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M21.704 24s.688-.346.688-1.578v-6.598c0-1.284-.838-1.86-1.74-2.156-.76-.243-1.72.022-2.28.354-.955.564-2.268.856-3.253 1.37V8.058L19.053 6v7.06c1.386-.597 3.055-2.062 4.881-1.331.802.321 2.066 1.41 2.066 2.815V24h-4.296Zm-4.407 0h-2.174l-.004-7.826h2.039c1.024 0 1.851.524 1.847 1.817v3.882c0 .92-.47 2.127-1.708 2.127ZM5 24c1-1.319 5.905-8.853 6.995-14.087V24H5Z',
      fill: '#fff',
    }),
  );
});
bohSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var boh = {
  category: 'brand',
  colorable: false,
  name: 'boh',
  svg: bohSvg,
};
